<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-button type="primary" plain @click="addProjectShow()">新增</el-button>
<!--      <el-input prefix-icon="el-icon-search" placeholder="输入项目名称查询" v-model="searchKeyword" style="width: 300px"></el-input>-->
<!--      <el-button type="primary" plain @click="getSearchData()">查询</el-button>-->
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="编号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="project_name"
          label="项目名称"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="project_amount"
          label="项目金额"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="收费周期"
          min-width="70"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.project_cycle_unit === 1">月</span>
            <span v-if="scope.row.project_cycle_unit === 2">季</span>
            <span v-if="scope.row.project_cycle_unit === 3">年</span>
            <span v-if="scope.row.project_cycle_unit === 4">天</span>
            <span v-if="scope.row.project_cycle_unit === 5">一次性</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="project_cycle_num"
          label="周期数量"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          label="状态"
          min-width="70"
          align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.project_status === 1">正常</span>
              <span v-if="scope.row.project_status === 2">停用</span>
            </template>
        </el-table-column>
        <el-table-column
          prop="project_remark"
          label="备注"
          min-width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          min-width="90"
          align="center">
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editCharge(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delCharge(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{addEditTitle}}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-charge :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-charge>
    </el-dialog>
  </div>
</template>

<script>
import addEditCharge from './components/addEditCharge'
import {queryfinanceproject, deletefinanceproject} from '../../api/yanglaoyuan'

export default {
  name: 'chargeItem',
  components: {addEditCharge},
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 1, name: 11}],
      searchKeyword: '',
      addEditShow: false,
      addEditTitle: '',
      addEditObj: {
        isAdd: true,
        row: ''
      },
      entityId: 0
    }
  },
  created () {
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getTableData()
  },
  methods: {
    getTableData () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId
      }
      queryfinanceproject(params, data).then(res => {
        this.tableData = res.data.financeProject
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    updateTable () {
      console.log('change')
      this.getTableData()
    },
    getSearchData () {},
    addProjectShow () {
      this.addEditTitle = '新增收费项目'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editCharge (row) {
      this.addEditTitle = '编辑收费项目'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delCharge (row) {
      this.$confirm('此操作将永久删除该收费项目【' + row.project_name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletefinanceproject(data).then(res => {
          this.$notify({ title: '成功', message: '删除成功', type: 'success', duration: 2000 })
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getTableData()
        }).catch(() => {})
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/chargeItem.vue